import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const attachmentsList = style({
  display: 'flex',
  minWidth: 0,
  gap: 8
})

export const attachmentItem = style({
  height: 31,
  display: 'flex',
  padding: '0 8px',
  alignItems: 'center',
  minWidth: 100,
  gap: 12,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  color: vars.color.dark,
  borderRadius: 5,
  border: `2px solid ${vars.color.dark}`,
  backgroundColor: vars.color.white
})

export const attachmentLabel = style({
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const attachmentRemove = style({
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  transition: 'color 0.2s',
  marginLeft: 'auto',
  color: vars.color.danger,

  ':hover': {
    color: vars.color.dangerLighter
  }
})

export const attachmentDropdownWrapper = style({
  position: 'relative',
  marginLeft: 'auto'
})

export const attachmentDropdownPortal = style({
  zIndex: 9999
})

export const attachmentDropdownTrigger = style({
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  transition: 'color 0.2s',

  ':hover': {
    color: vars.color.medium
  }
})

export const attachmentDropdown = style({
  backgroundColor: vars.color.white,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  color: vars.color.dark,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  padding: '8px 16px'
})

export const attachmentDropdownItem = style({
  padding: 8,
  display: 'flex',
  maxWidth: 300,
  gap: 8
})
